import type { BaseModel, IExtra } from './createRequest';
export type IFetch<Model extends BaseModel> = {
    [K in keyof Model]: (
        payload?: any,
        config?: {
            extra?: IExtra;
        }
    ) => any;
};

const fetchMap = {};
export function createUseRequestMap<IModels extends BaseModel>(useHttp: any) {
    return new Proxy(fetchMap, {
        get(target, prop) {
            return (...args: any) => useHttp(prop, ...args);
        },
    }) as IFetch<IModels>;
}
